import * as React from "react"
import * as styles from "./styles.css"
import { DataLayerSection } from "./data-layer-section"
import { DataSourcesSection } from "./data-sources-section"
import { CmsProvider } from "@gatsbyjs/graphql"
import { Link } from "@gatsbyjs/reach-router"

export type DataSourcesSiteSettingsProps = {
  siteId: string
  organizationId: string
  permissionToEdit: boolean
  quickConnectControls: {
    setCmsToEdit: React.Dispatch<React.SetStateAction<CmsProvider | null>>
    setCmsToRemove: React.Dispatch<React.SetStateAction<CmsProvider | null>>
    controlModals: JSX.Element
  }
}

export function DataSourcesSiteSettings({
  siteId,
  organizationId,
  permissionToEdit,
  quickConnectControls,
}: DataSourcesSiteSettingsProps) {
  return (
    <div className={styles.root}>
      <DataLayerSection
        siteId={siteId}
        organizationId={organizationId}
        permissionToEdit={permissionToEdit}
      />
      <DataSourcesSection
        siteId={siteId}
        quickConnectControls={quickConnectControls}
        permissionToEdit={permissionToEdit}
      />
      <div className={styles.card} id="webhook">
        <h3 className={styles.cardHeading}>Webhook</h3>
        <p>
          Not using any of the above? Use your site’s{" "}
          <Link
            to={`/dashboard/${organizationId}/sites/${siteId}/settings/general#webhook`}
          >
            Build and Preview webhooks
          </Link>{" "}
          to trigger production and CMS Preview builds.
        </p>
      </div>
    </div>
  )
}
